<template lang="pug">
b-modal#addPhone(
  ref="addPhone"
  :title="$t('ui.combine.add_phone')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  :hide-footer="mode == 'batch'"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-button-group.toggle.mb-3(:pressed.sync="mode", size="sm")
        b-button(:variant="mode === 'single' ? 'primary' : 'outline-secondary'", @click="changeACTab('single')") {{ $t("ui.single") }}
        b-button(:variant="mode === 'batch' ? 'primary' : 'outline-secondary'", @click="changeACTab('batch')") {{ $t("ui.batch") }}
      template(v-if="mode == 'single'")
        b-form-group(:label="$t('ui.phone')").mb-0
          DebounceInput(
            size="sm"
            ref="phone"
            required
            type="text"
            :dirty="$v.phone.$dirty"
            :error="$v.phone.$error"
            v-model.trim.lazy="$v.phone.$model"
            :disabled="loading"
          )
          small.form-text.text-muted {{  getCpiOpPhoneToolTip() }}
          ValidateResult(:value="$v.phone" :name="$t('ui.phone')" :currencyCode="getCurrencyCode")
      template(v-else)
        b-form-group.mb-1
          label {{ $t('ui.phone') }}
          i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.excel_format')" @click="showSample = !showSample" style="cursor: pointer;")
          br
          img.mt-2.mb-2(
            v-if="showSample"
            :src="'/assets/img/excel-format.png'"
            alt="Excel Sample"
            style="max-width: 100%; max-height: 200px; border: 1px solid #ddd; padding: 4px;"
          )
          b-form-file(
            ref="fileInput"
            v-model="excelFile"
            accept=".xls,.xlsx"
            @change="handleFileUpload"
            browse-text="Browse"
            :placeholder="$t('message.choose_an_excel_file')"
          )

    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
// const phoneStartWithVi = helpers.regex("phoneStartWithVi", /^84[a-z\d\-_ ]*$/i);

export function phoneStartWith(prefix) {
  return helpers.regex(
    "phoneStartWith" + prefix,
    new RegExp(`^${prefix}[a-z\\d\\-_ ]*$`, "i")
  );
}

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      social_platform: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      mode: 'single',
      phone: '',
      showSample: false,
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  validations() {
    const currencyCode =  this.getCurrencyCode.toLowerCase()
    var prefix = '84'
    if(currencyCode == 'myr') {
      prefix = '60'
    }
    return {
      phone: {
        integer,
        required,
        // phoneStartWithVi
        phoneStartWith: phoneStartWith(prefix)
      }
    }
  },
  methods: {
    getCpiOpPhoneToolTip() {
      var msg = this.$t('message.tooltips_add_cpi_op_phone')
      var currencyCode = this.getCurrencyCode.toLowerCase()
      if(currencyCode == 'myr') {
        msg = this.$t('message.tooltips_add_cpi_op_phone_' + currencyCode)
      }

      return msg;
    },
    changeACTab(mode) {
      if(this.mode == mode) return;
      if(this.mode == 'single')
        this.$v.$reset();
      else
        this.$refs.fileInput.reset();

      this.mode = mode
      this.phone = ''
      this.excelFile = null
      this.showSample = false
    },
    done: function(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submit(this.phone);
    },
    submit: function(phone) {
      let url = config.cpiOperatorPhoneAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        phone_list: phone
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addPhone.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_phone", this.feedback.status);
                this.$refs.addPhone.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];

      const validExtensions = ['.xlsx', '.xls'];
      const fileName = file.name.toLowerCase();
      const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
      const hasValidType = validTypes.includes(file.type);

      if (!hasValidExtension || !hasValidType) {
        this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.please_select_valid_excel_file"), "error");

        this.excelFile = null;
        this.$refs.fileInput.reset();
        this.$nextTick(() => {
          this.$refs.addCustomer.hide();
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
        const dataRows = rows.slice(1); // Remove header row

        const phone = dataRows
          .map(row => row[0].toString().trim()) // Take first column, ensure string
          .filter(phone => phone); // Remove empty or null

        // Validate phone
        const hasInvalidPhone = phone.some(row =>
          !row || !/^\d+$/.test(row.toString().trim())
        );

        if (hasInvalidPhone) {
          this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.please_enter_valid_phone"), "error");

          this.excelFile = null;
          this.$refs.fileInput.reset();
          this.$nextTick(() => {
            this.$refs.addPhone.hide();
          });
          return;
        }

        this.submit(phone.join(","));
      };

      reader.readAsArrayBuffer(file);
    },
    // submitBatch(list) {
    //   if(list.length <= 0) {
    //     this.$helpers.showToast(this.$t("ui.alert"), this.$t("message.please_enter_phone"), "error");
    //     this.$nextTick(() => {
    //       this.$refs.addCustomer.hide();
    //     });
    //     return
    //   }
    //   let url = config.customerAddUrl();

    //   var json = {
    //     auth_token: this.$store.getters.sessionToken,
    //     action_by: this.$store.getters.loginId,
    //     list: list
    //   };

    //   this.feedback.success = true;
    //   this.loading = true;

    //   this.$http.post(url, json).then(
    //   function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.data.status == "1";
    //           } else {
    //             this.feedback.success = response.data.status == 1;
    //           }
    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             this.$emit("clicked");
    //           } else {
    //             this.$helpers.handleFeedback(this.feedback.status);
    //             var errorList = response.data.errorList;
    //             let html =
    //               "<div class='mb-2'>" + this.$t("error." + this.feedback.status) + "</div>" +
    //               "<div class='clusterize-scroll table-responsive'>" +
    //                 "<table class='table table-sm table-bordered table-striped table-hover table-align-middle'>" +
    //                   "<thead class='thead-light'>" +
    //                     "<tr>" +
    //                       "<th class='text-left' width='5%'><span title='" + this.$t('ui.phone') + "'>" + this.$t('ui.phone') + "</span></th>" +
    //                       "<th class='text-center' width='11%'><span title='" + this.$t('ui.status') + "'>" + this.$t('ui.status') + "</span></th>" +
    //                     "</tr>" +
    //                   "</thead>" +
    //                   "<tbody class='clusterize-content'>";

    //             if (errorList.length === 0) {
    //               html +=
    //                 "<tr><td class='text-center'><span>" + this.$t('message.no_data_available') + "</span></td></tr>";
    //             } else {
    //               errorList.forEach(item => {
    //                 html +=
    //                   "<tr>" +
    //                     "<td class='text-left'><span title='" + item.phone + "'>" + item.phone + "</span></td>" +
    //                     "<td><span title='" + item.statusdesc + "'>" + item.statusdesc + "</span></td>" +
    //                   "</tr>";
    //               });
    //             }

    //             html +=
    //                 "</tbody>" +
    //               "</table>" +
    //             "</div>";

    //             this.$swal({
    //               title: this.$t("ui.alert"),
    //               html: html,
    //               type: 'error',
    //             })
    //           }
    //           this.$nextTick(() => {
    //             this.$refs.addCustomer.hide();
    //           });
    //         }
    //       } catch (error) {
    //         this.loading = false;
    //         if (error.status.toLowerCase() == "nochanges") {
    //           this.$emit("clicked");
    //           this.$nextTick(() => {
    //             this.$refs.addCustomer.hide();
    //           });
    //         } else {
    //           this.feedback.success = false;
    //           this.feedback.status = error.status;
    //           this.$helpers.handleFeedback(this.feedback.status);
    //         }
    //       }
    //     },
    //     function() {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.handleFeedback(this.feedback.status);
    //     }
    //   );
    // },
    reset: function() {
      this.$v.$reset();
      this.mode = 'single'
      this.phone = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.mode = 'single'
      this.phone = ''
      this.excelFile = null
      this.showSample = false
    }
  }
};
</script>
